import React from 'react'
import styled from 'styled-components';
import Section from './Section';

function Home() {
  return (
     <Container>
        <Section title="Model S"
                 description="Order Online for touchless Delivery" 
                 backgroundImg = "model-s.jpg"
                 leftButtontext = "custom order"
                 rightButtontext = "Existing Inventory"/>

        <Section title="Model Y"
                 description="Order Online for touchless Delivery" 
                 backgroundImg = "model-y.jpg"
                 leftButtontext = "custom order"
                 rightButtontext = "Existing Inventory"/>

        <Section title="Model 3"
                 description="Order Online for touchless Delivery" 
                 backgroundImg = "model-3.jpg"
                 leftButtontext = "custom order"
                 rightButtontext = "Existing Inventory"/>

        <Section title="Model X"
                 description="Order Online for touchless Delivery" 
                 backgroundImg = "model-x.jpg"
                 leftButtontext = "custom order"
                 rightButtontext = "Existing Inventory"/>

         <Section title="Lowest Cost Solar Panels in America"
                 description="Money-back guarantee" 
                 backgroundImg = "solar-panel.jpg"
                 leftButtontext = "Order Now"
                 rightButtontext = "Learn More"/>
                 
        <Section title="Solar Roof"
                 description="Produce clean energy from your Roof" 
                 backgroundImg = "solar-roof.jpg"
                 leftButtontext = "Order Now"
                 rightButtontext = "Learn More"/>

        <Section title="Accessories"
                 description=" "
                 backgroundImg = "accessories.jpg"
                 leftButtontext = "Shop Now"/>

       <Footer>
         <FooterItems>
             <a href="#">Tesla2022</a>
             <a href="#">Privacy</a>
             <a href="#">Vehicle Recalls</a>
             <a href="#">Contact</a>
             <a href="#">Career</a>
             <a href="#">News</a>
             <a href="#">Engage</a>
             <a href="#">Location</a>
         </FooterItems>
       </Footer>
                 

        
                 
     </Container>
  );
}

const Container = styled.div` 

height:100vh;

`
const Footer = styled.div`
     width:100%
     min-height:40px ;
     display:flex;
     justify-content:center;
     align-items:center;
    
`;
const FooterItems = styled.div`
    display:flex;
   
    a{
      font-size:14px;
      font-weight:200;
      padding: 0px 10px;
    }
    @media (max-width:786px){
       flex-direction:column;
       a{
         padding:5px 0px;
       }
    }
`;

export default Home;